import {combineReducers, createSlice, Slice} from '@reduxjs/toolkit';
import floorplanResizeReducer from 'floorplan-v2/app/reducers/resize/slice';
import floorplanSectionsReducer from 'floorplan-v2/app/reducers/sections/slice';
import floorplanBookingsReducer from 'floorplan-v2/app/reducers/bookings/slice';
import floorplanTableInteractionsReducer from 'floorplan-v2/app/reducers/tableInteractions/slice';
import floorplanBlockoutsReducer from 'floorplan-v2/app/reducers/blockouts/slice';
import floorplanFilterReducer from 'floorplan-v2/app/reducers/floorplanFilter/slice';
import floorplanSettingsReducer from 'floorplan-v2/app/reducers/settings/slice';
import floorplanTableDragReducer from 'floorplan-v2/app/reducers/tableDrag/slice';
import {IScheduleState} from "app/reducers/schedule/types";
import {IServiceState} from "app/reducers/service/types";
import {IVenueState} from "app/reducers/venue/types";
import {IBookingState} from "app/reducers/booking/types";
import { ISettingState } from 'app/reducers/settings/types';
import { IResizerState } from 'app/reducers/resizer/types';
import { ILayoutState } from 'app/reducers/layout/types';


export const floorplanV2Reducers = {
  floorplanResizeReducer,
  floorplanSectionsReducer,
  floorplanBookingsReducer,
  floorplanTableInteractionsReducer,
  floorplanBlockoutsReducer,
  floorplanFilterReducer,
  floorplanSettingsReducer,
  floorplanTableDragReducer,
};

export const floorplanV2StandaloneReducers = {
  scheduleReducer : createSlice({ name: 'schedule', initialState: {} as IScheduleState, reducers: {} }).reducer,
  serviceReducer : createSlice({ name: 'service', initialState: {} as IServiceState, reducers: {} }).reducer,
  venueReducer:  createSlice({ name: 'venue', initialState: {} as IVenueState, reducers: {} }).reducer,
  bookingReducer:  createSlice({ name: 'booking', initialState: {} as IBookingState, reducers: {} }).reducer,
  settingReducer:  createSlice({ name: 'settings', initialState: {} as ISettingState, reducers: {} }).reducer,
  resizerReducer:  createSlice({ name: 'resizer', initialState: {} as IResizerState, reducers: {} }).reducer,
  layoutReducer:  createSlice({ name: 'layout', initialState: {} as ILayoutState, reducers: {} }).reducer,
  ...floorplanV2Reducers
}
export const floorplanV2RootReducer = combineReducers(floorplanV2Reducers)
export const floorplanV2StandaloneReducer = combineReducers(floorplanV2StandaloneReducers)
// export type FloorplanV2State = ReturnType<typeof floorplanV2RootReducer>;
export type FloorplanV2State = ReturnType<typeof floorplanV2StandaloneReducer>;

